"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = require("react");
const useFocus = (dependancies = []) => {
    const ref = react_1.useRef();
    const [focusRef, setFocusRef] = react_1.useState();
    react_1.useEffect(() => {
        var _a;
        if (ref)
            setFocusRef(ref);
        if (focusRef) {
            (_a = focusRef.current) === null || _a === void 0 ? void 0 : _a.focus();
        }
    }, [setFocusRef, focusRef, ...dependancies]);
    return [focusRef, setFocusRef];
};
exports.default = useFocus;
